import { FC, useState } from "react"
import VkID from "@assets/svg/VKIcon.svg?react"
import { useVkOAuth } from "@/app/data/oauth2/VkOAuth2Provider"
import { IconButton } from "@mui/material"

const VkAuthButton: FC = () => {
	const [disabled, setDisabled] = useState(false)
	const openDialog = useVkOAuth()
	const clickHandler =  () => {
		setDisabled(true)
		setTimeout(() => {
			setDisabled(false)
		}, 3000)
		openDialog()
	}
	return <IconButton
	disabled={disabled}
			onClick={clickHandler}
			size="large"
			sx={{
				bgcolor: "white",
				color: "black",
				border: "1px solid #e0e0e0",
				"&:hover": {
					bgcolor: "#fff8e1",
				},
				// Важно: делаем SVG нужного размера
				"& svg": {
					width: 28,
					height: 28,
				},
			}}
	>
		<VkID/>
	</IconButton>
}
export default VkAuthButton